export enum StorageValues {
  HiddenMuteModalEvents = 'hiddenMuteModalEvents',
  DismissMessages = 'dismissMessages',
  Assistant = 'assistant',
  ExtraLaunchArgs = 'extraLaunchArgs',
  TransitionLoadingScreen = 'transitionLoadingScreen',
  TutorialPromptDecision = 'tutorialPromptDecision',
  CompletedTutorials = 'completedTutorials',
}

export enum StorageTypes {
  Local = 'local',
  Session = 'session',
}
